export const GET_SETTINGS = 'APPLCIATION_SETTINGS/get_settings';
export const GET_SINGLE_SETTING = 'APPLCIATION_SETTINGS/get_single_setting';
export const UPDATE_SETTING = 'APPLCIATION_SETTINGS/update_setting';

export const FORM_DATA = {
  max_pending_applications: '',
};